// Shared badge for invoice status (draft / sent / pending / paid)
import { useAuth } from "../context/AuthContext";
const STATUS_CFG = {
  draft:   { label: "Draft",   dot: "bg-muted-foreground",       cls: "bg-muted text-muted-foreground border border-border" },
  sent:    { label: "Outstanding",    dot: "bg-[hsl(var(--accent-sage))]", cls: "bg-[hsl(var(--accent-sage-soft))] text-[hsl(var(--accent-sage))] border border-[hsl(var(--accent-sage))]/25" },
  pending: { label: "Pending", dot: "bg-[hsl(var(--primary))]",  cls: "bg-[hsl(var(--accent-gold-soft))] text-[hsl(var(--primary))] border border-[hsl(var(--primary))]/20" },
  paid:    { label: "Paid",    dot: "bg-[#2E7D32]",              cls: "bg-[#E8F2EA] text-[#2E7D32] border border-[#2E7D32]/15" },
};

export function InvoiceStatusBadge({ status }) {
  const { user } = useAuth();
  const cfg = STATUS_CFG[status] || STATUS_CFG.pending;
  const label = user?.role === "franchisee" && (status === "sent" || status === "pending") ? "Invoice Received · Outstanding" : cfg.label;
  return (
    <span className={`text-[11px] px-2.5 py-1 rounded-full font-medium tracking-wide inline-flex items-center gap-1 ${cfg.cls}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${cfg.dot}`} />
      {label}
    </span>
  );
}
